import React from "react";
import eventBus from "../../utils/eventBus";
import "../../styles/components/blocks/popup.scss";

/** JPG **/
import PopupDesktopRetina from "../../images/popup/popup-desktop-x2.jpg";
import PopupDesktop from "../../images/popup/popup-desktop.jpg";
import PopupMobileRetina from "../../images/popup/popup-mobile-x2.jpg";
import PopupMobile from "../../images/popup/popup-mobile.jpg";

/** WEBP **/
import PopupDesktopRetinaWebp from "../../images/popup/popup-desktop-x2.webp";
import PopupDesktopWebp from "../../images/popup/popup-desktop.webp";
import PopupMobileRetinaWebp from "../../images/popup/popup-mobile-x2.webp";
import PopupMobileWebp from "../../images/popup/popup-mobile.webp";

const Popup = ({ context }) => {
  const lang = context.pageContext.locale;

  const closePopup = () => {
    const popup = document.querySelector(".bi__popup-wrapper");
    popup.style.opacity = 0;
    popup.style.visibilty = "hidden";
    popup.style.pointerEvents = "none";
  };

  const content = {
    title: {
      fr: "Familles bienvenues",
      en: "Families welcome",
    },
    subtitle: {
      fr: {
        a: "Du 1er juin au 31 août, ",
        b: "le petit déjeuner est offert pour les enfants ",
        c: "lors de votre séjour aux Suites de l'Île Barbe.",
      },
      en: {
        a: "From June 1 to August 31, ",
        b: "breakfast is free for children ",
        c: "during your stay at the Suites de l'Île Barbe.",
      },
    },
    question: {
      fr: "Une occasion idéale de profiter en famille d’un moment de sérénité et de nature.",
      en: "An ideal opportunity for the whole family to enjoy a moment of serenity and nature.",
    },
    button: {
      url: "https://booking.roomcloud.net/be/se2/hotel.jsp?hotel=17608",
      label: {
        fr: "réserver",
        en: "book",
      },
    },
  };

  return (
    <>
    </>
  );
};

export default Popup;
